import { Flex, Typography } from '@aloft/toolkit-sui';

import { selectCompTypeReconciliationData } from '../../../redux/features/selectors/selectReconciliationData.ts';
import { useAppSelector } from '../../../redux/hooks.ts';

type ReconciliationSummarizedValuesProps = {
  compType?: 'aiv' | 'arv';
};

export const ReconciliationSummarizedValues = ({
  compType,
}: ReconciliationSummarizedValuesProps) => {
  const reconciliationData = useAppSelector((state) =>
    selectCompTypeReconciliationData(state, compType),
  );

  return (
    <Flex
      backgroundColor="surface6"
      borderColor="strokeDefault"
      borderStyle="solid"
      borderWidth="1px"
      borderRadius="5px"
      padding="15px"
      flexDirection="column"
      gap={4}
    >
      <Flex width="100%" justifyContent="space-between" alignItems="center">
        <Typography variant="body1" color="textSecondary">
          Indicated Value by Cost Approach
        </Typography>
        <Typography variant="body1" color="textPrimary">
          {reconciliationData?.costApproachValue?.toString(true) ?? 'N/A'}
        </Typography>
      </Flex>
      <Flex width="100%" justifyContent="space-between" alignItems="center">
        <Typography variant="body1" color="textSecondary">
          Adjusted Sales Price Range
        </Typography>
        <Typography variant="body1" color="textPrimary">
          {reconciliationData?.minCompMarketAdjustedSalePrice?.toString(true) ?? 'N/A'} -{' '}
          {reconciliationData?.maxCompMarketAdjustedSalePrice?.toString(true) ?? 'N/A'}
        </Typography>
      </Flex>
      <Flex width="100%" justifyContent="space-between" alignItems="center">
        <Typography variant="body1" color="textSecondary">
          Average Comparable Adjusted Sale Price
        </Typography>
        <Typography variant="body1" color="textPrimary">
          {reconciliationData?.averageCompMarketAdjustedSalePrice?.toString(true) ?? 'N/A'}
        </Typography>
      </Flex>
      <Flex width="100%" justifyContent="space-between" alignItems="center">
        <Typography variant="body1" color="textSecondary">
          Median Comparable Adjusted Sale Price
        </Typography>
        <Typography variant="body1" color="textPrimary">
          {reconciliationData?.medianCompMarketAdjustedSalePrice?.toString(true) ?? 'N/A'}
        </Typography>
      </Flex>
      <Flex width="100%" justifyContent="space-between" alignItems="center">
        <Typography variant="body1" color="textSecondary">
          Average Comparable Days on Market
        </Typography>
        <Typography variant="body1" color="textPrimary">
          {reconciliationData?.averageCompDaysOnMarket
            ? `${reconciliationData?.averageCompDaysOnMarket} days`
            : 'N/A'}
        </Typography>
      </Flex>
      <Flex width="100%" justifyContent="space-between" alignItems="center">
        <Typography variant="body1" color="textSecondary">
          Median Comparable Days on Market
        </Typography>
        <Typography variant="body1" color="textPrimary">
          {reconciliationData?.medianCompDaysOnMarket
            ? `${reconciliationData?.medianCompDaysOnMarket} days`
            : 'N/A'}
        </Typography>
      </Flex>
    </Flex>
  );
};
